"use client";
import { useMemo as o } from "react";
import { E as d } from "./utils.CjOCBPlS.js";
const m = ({
  styles: e,
  defaultClass: s,
  extendedStyles: t,
  selectors: l
}) => o(() => d({ styles: e, defaultClass: s, extendedStyles: t, selectors: l }), [e, s, l, t]);
export {
  m as u
};
//# sourceMappingURL=usePresentationClassWithSelectors.CPSUZ4pK.js.map
